import './material.css';

function importAll(r) {
    return r.keys().map(r);
}

const docs = importAll(require.context('/src/assets/docs', false, /\.(pdf)$/));
const images = importAll(require.context('/src/assets/images', false, /\.(png|jpe?g|svg)$/));
// const video = importAll(require.context('/src/assets/video', false, /\.(mp4)$/));

export default function Material() {

    const docList = docs.map((elem, index) => {
        var name = elem.split('/').pop().split('.')[0];
        return <li key={index}><a href={elem} rel="noreferrer" target="_blank">{name}</a></li>
    })

    const closeModal = () => {
        var modal = document.getElementById("modal");
        modal.style.display = "none";
    }

    const showImageInModal = (e) => {
        var modalImg = document.getElementById("modal-img");
        modalImg.src = e.target.src;
        const el = e.target;
        const t = el.getBoundingClientRect().top;
        modalImg.style.marginTop = t+"px";
        var modal = document.getElementById("modal");
        modal.style.display = "block";     
    }

    const imageList = images.map((elem, index) => {
        return <img key={index} id={"img"+index} src={elem} alt="" onClick={showImageInModal} ></img>
    })

    return (
        <div id="material" className="material">
            <h2 className="material-title">Materijal za pripremu</h2>
            <section id="docs">
                <h3 className="docs-title">Primeri prijemnih ispita iz prethodnih godina</h3>
                <ul className="doc-list">
                    { docList }
                </ul>
            </section>
            <section id="photo-example">
                <h3 className="photo-example-title">Isečak iz materijala za pripremu</h3>
                <div id="modal" className="modal" onClick={ closeModal }>
                    <img id="modal-img" className="modal-content" alt=""></img>
                </div>
                <div className="image-conatainer">
                    { imageList }
                </div>
            </section>
            {/* <section id="video-example">
                <h3 className="video-example-title">Video primer časa</h3>
                <div className="video-conatiner">
                    <video width="640" height="480" controls>
                        <source src={video}></source>
                        Your browser does not support the video tag.
                    </video>
                </div>
            </section> */}
        </div>
    );
}